module.exports = __webpack_public_path__ + "static/media/logo-mono-anthem.2ee554f3.svg";